import React from "react";
import DataView from "./dataView";

const OperationalDataView = () => {
	return <DataView section="operative" />;
};

export default OperationalDataView;
